module.exports = __webpack_public_path__ + "static/locales/en.1G3N4v4.json";